import React from "react";
import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";

const PushCompleteAlert = ({ message, status = "success", errors = 0, recordsProcessed = 0, onReturn }) => {
  const severity = status === "partial" ? "warning" : status === "failed" ? "error" : "success";
  const title = severity === "success"
    ? "✅ Push Complete"
    : severity === "warning"
      ? "⚠️ Push Partially Complete"
      : "❌ Push Failed";

  return (
    <Alert severity={severity} sx={{ mb: 3 }}>
      <AlertTitle>{title}</AlertTitle>
      <Typography variant="body1">{message}</Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        {recordsProcessed} inserted · {errors} error{errors === 1 ? "" : "s"}
      </Typography>
      <Box mt={2}>
        <Button variant="outlined" onClick={onReturn}>
          Return to Collection
        </Button>
      </Box>
    </Alert>
  );
};

export default PushCompleteAlert;
